import { render, staticRenderFns } from "./PaginatedQuery.vue?vue&type=template&id=632ca70a&"
import script from "./PaginatedQuery.vue?vue&type=script&lang=ts&"
export * from "./PaginatedQuery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports